import React, { createContext, useContext, useMemo, useCallback } from "react";
import hr from "./hr.json";
import en from "./en.json";

const dictionaries = { hr, en };

const I18nContext = createContext({
  lang: "hr",
  t: (key) => key,
});

function getFromKey(obj, key) {
  if (!obj || !key) return undefined;
  return key.split(".").reduce((acc, part) => {
    if (acc && typeof acc === "object" && part in acc) return acc[part];
    return undefined;
  }, obj);
}

export function I18nProvider({ lang, children }) {
  const safeLang = dictionaries[lang] ? lang : "hr";
  const dict = dictionaries[safeLang];

  const t = useCallback(
    (key, fallback) => {
      const value = getFromKey(dict, key);
      if (value === undefined || value === null) {
        return fallback !== undefined ? fallback : key;
      }
      return value;
    },
    [dict]
  );

  const value = useMemo(() => ({ lang: safeLang, t }), [safeLang, t]);

  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export function useI18n() {
  return useContext(I18nContext);
}

export function useT() {
  return useContext(I18nContext).t;
}
